import React from 'react';
import DayPicker from 'react-day-picker';
import { withLocalize } from 'react-localize-redux';
import MomentLocaleUtils from 'react-day-picker/moment';
import { isFunction, isNullOrUndefined } from "../../store/storeFunctions";
import moment from 'moment';
import classNames from "classnames";
import { registerHook, isClickToClass, isClickTo } from "../../store/clickWrapper";
import CalendarIcon from '../../img/icons/Kalendar';
import { connect } from 'react-redux';
import { ErrorMessage } from "formik";

class YearMonthForm extends React.Component {

    state = {
        year: this.props.date instanceof Date ? this.props.date.getFullYear() : new Date().getFullYear(),
        month: this.props.date instanceof Date ? this.props.date.getMonth() : new Date().getMonth()
    }

    render() {
        const years = [];
        const currentYear = new Date().getFullYear();
        const fromMonth = new Date(currentYear - this.props.yearsBack, 0);
        const toMonth = new Date(currentYear + this.props.yearsFuture, 11);

        for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1)
            years.push(i);

        const months = moment.localeData(this.props.locale).months();

        return (
            <div className="picker-row" >
                <div className="trngl"></div>
                <div className="trngl-2"></div>
                <div className="select"  >
                    <select name="year" style={{ width: "100%" }} onChange={(e) => this.onYearChange(e.target.value)} value={this.state.year}>
                        {years.map(year => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="select">
                    <select name="months" style={{ width: "100%" }} onChange={(e) => this.onMonthChange(e.target.value)} value={this.state.month}>
                        {months.map((m, ind) => (
                            <option key={ind} value={ind}>
                                {m}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        );
    }

    onYearChange(year) {
        const currentYear = new Date().getFullYear();
        const maxDate = new Date(currentYear + this.props.yearsFuture, 11, 31);

        let tempDate = new Date(this.props.date)
        if (tempDate instanceof Date) {
            tempDate.setFullYear(parseInt(year));
            if (tempDate <= (this.props.yearsFuture >= 1 ? maxDate : new Date())) {
                let newDate = new Date(new Date(tempDate).setFullYear(year));
                this.setState({ year: parseInt(year) });
                this.props.callback(newDate)
            } else {
                this.props.callback(new Date());
            }
        }
    }

    onMonthChange(month) {
        const currentYear = new Date().getFullYear();
        const maxDate = new Date(currentYear + this.props.yearsFuture, 11, 31);

        let tempDate = new Date(this.props.date)
        if (tempDate instanceof Date) {
            tempDate.setMonth(parseInt(month));
            if (tempDate <= (this.props.yearsFuture >= 1 ? maxDate : new Date())) {
                this.setState({ month: parseInt(month) });
                let newDate = new Date(new Date(tempDate).setMonth(parseInt(month)));
                this.props.callback(newDate)
            } else {
                this.props.callback(new Date());
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.date !== this.props.date) {
            this.setState({ year: this.props.date instanceof Date ? new Date(this.props.date).getFullYear() : new Date().getFullYear() });
            this.setState({ month: this.props.date instanceof Date ? new Date(this.props.date).getMonth() : new Date().getMonth() });
        }
    }
}

class BbDatePicker extends React.Component {
    static defaultProps = {
        formDateFormat: "DD.MM.YYYY",
        enableReinitialize: false,
        afterReinitialize: null,
        showError: false,
        hasValidationError: false,
        useShadowOnError: false,
        onFocus: undefined,
        onBlur: undefined,
        noMaxDate: false,
        allowInvalidValue: false,
        strict: true,
        additionalClasses: {},
        yearsBack: 20,
        yearsFuture: 10
    };

    format = "DD.MM.YYYY";
    altFormat = "D.M.YYYY"
    mounted = false;
    overlay = undefined;
    dayInputRef = undefined;
    inpt = undefined;
    fitToBottom = false;

    state = {
        value: this.props.value,
        open: false,
        error: false,
        date: moment(this.props.value, this.props.formDateFormat, this.props.strict).isValid() ? moment(this.props.value, this.props.formDateFormat).toDate() : new Date(),
        inputValue: moment(this.props.value, this.props.formDateFormat, this.props.strict).isValid()
            ? moment(this.props.value, this.props.formDateFormat, this.props.strict).format(this.format) : (this.props.allowInvalidValue ? this.props.value : "")
    }

    render() {
        var rightBorderClass = '';
        if (this.props.hasRightBorder)
            rightBorderClass = ' has-right-border';
        return (<>
            <div ref={(el) => this.inputRef(el)} className="day-picker-ultimate" style={this.props.style}>
                {this.state.open &&
                    <div className={classNames(`fake-overlay${rightBorderClass}`, { "right-panel": this.props.rightPanel }, { "top": !this.state.fitToBottom }, { "bottom": this.state.fitToBottom })}
                        onClick={(e) => this.handleClick(e)} ref={(el) => this.pickerRef(el)}
                        style={this.props.overlayStyle}
                    >
                        <YearMonthForm
                            date={this.state.date}
                            callback={this.onDateChange}
                            yearsBack={this.props.yearsBack}
                            yearsFuture={this.props.noMaxDate === true ? this.props.yearsFuture : 0}
                            locale={this.props.user.language}
                        />
                        <DayPicker
                            disabledDays={this.props.noMaxDate === true ? undefined : { after: new Date() }}
                            localeUtils={MomentLocaleUtils}
                            locale={moment.locale()}
                            selectedDays={this.state.date}
                            onDayClick={(x) => x >= new Date() + 1 ? () => { } : this.onDateChange(x, true)}
                            onMonthChange={(x) => x >= new Date() + 1 ? () => { } : this.onDateChange(x, false)}
                            month={this.state.date}
                        ></DayPicker>
                    </div>
                }
                {this.props.hideIcon !== true && <CalendarIcon
                    className={classNames({ "calendar": true, "is-disabled": this.props.disabled })}
                    fill="currentColor"
                    onClick={() => this.setState({ open: !this.props.calendarHidden })}
                />}
                <input autoComplete="off" type="text" ref={(el) => this.inpt = el} className={classNames(this.props.inputClass || "input", {
                        "is-danger": !this.props.useShadowOnError && (this.state.error || this.props.hasValidationError),
                        "no-icon": this.props.hideIcon === true,
                        "is-invalid": this.props.useShadowOnError && (this.state.error || this.props.hasValidationError),
                        ...this.props.additionalClasses
                    })}
                    onFocus={() => {
                        this.setState({ open: !this.props.calendarHidden })
                        if (isFunction(this.props.onFocus))
                            this.props.onFocus();
                    }}
                    onBlur={() => {
                        if (isFunction(this.props.onBlur))
                            this.props.onBlur();
                    }}
                    value={this.state.inputValue || ""}
                    onChange={(e) => this.onDateChange(e.target.value)}
                    placeholder={this.props.placeholder || ""}
                    disabled={this.props.disabled}
                    id={this.props.id}
                />
            </div>
            {this.props.showError && this.props.field && <ErrorMessage name={this.props.field} component="div" className="invalid-feedback" />}
        </>);
    }

    componentDidMount() {
        this.mounted = true;
        this.hookId = registerHook(this, (click) => {
            if (this.state.open && !isClickTo(click, [this.inpt, this.overlay]) && this.mounted) {
                this.setState({ open: false });
            }
        });
    }

    componentDidUpdate() {
        if (this.props.enableReinitialize === true && this.state.value !== this.props.value) {
            this.setState({
                value: this.props.value,
                date: moment(this.props.value, this.props.formDateFormat, this.props.strict).isValid() ? moment(this.props.value, this.props.formDateFormat).toDate() : new Date(),
                inputValue: moment(this.props.value, this.props.formDateFormat, this.props.strict).isValid()
                    ? moment(this.props.value, this.props.formDateFormat, this.props.strict).format(this.format) : (this.props.value || ""),
            }, () => {
                if (isFunction(this.props.afterReinitialize))
                    this.props.afterReinitialize();
            });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onDateChange = (text, close = false) => {
        const isEmpty = isNullOrUndefined(text) || typeof text === "string" && text.trim() === "";
        const isValid = isEmpty || moment(text, this.format, true).isValid() || moment(text, this.altFormat, true).isValid();

        if (isValid) {
            let asDate = isEmpty ? new Date() : moment(text, this.format).toDate()
            this.setState({ date: asDate })
        }

        let asString = (typeof text === "string" ? text : moment(text).format(this.format)).replace(/\s/g, '').replace(/[/\\]/g, '');
        this.setState({ inputValue: isValid ? asString : text, error: !isValid });
        close && isValid && this.setState({ open: false });
        
        if (!isNullOrUndefined(this.props.formik) && isValid)
        {
            this.props.formik.setFieldValue(`${this.props.field}`, isEmpty ? "" : moment(text, this.format).format(this.props.formDateFormat))
        }

        if (isFunction(this.props.afterDateChange))
            this.props.afterDateChange(asString, isValid);

        this.handleClick();
    }

    handleClick = (e) => {
        //close when clicked on day
        if (e !== undefined && this.state.open && this.mounted) {
            this.setState({ open: !isClickToClass(e, "DayPicker-Day") });

        }
    }

    inputRef = (el) => {
        if (el === null || el === undefined || this.dayInputRef === el) {
            return;
        }
        this.dayInputRef = el;
    }

    pickerRef = (el) => {
        if (el === null || el === undefined || this.overlay === el) {
            return;
        }
        this.overlay = el
        this.solvePosition();
    }

    solvePosition = () => {
        if (this.overlay === null || this.overlay === undefined) {
            return;
        }
        let parentRect = this.dayInputRef.getBoundingClientRect();
        let pickerRect = this.overlay.getBoundingClientRect();

        const fitToBottom = !((parentRect.y + (parentRect.height * 2.25) + pickerRect.height) <= (document.documentElement.scrollHeight - window.scrollY));
        if (this.state.fitToBottom != fitToBottom) {
            this.setState({ fitToBottom })
        }
    }
}

export default withLocalize(connect(
    state => { return { user: state.userContext } },
    null
)(BbDatePicker));